import { TOGGLE_SIDE_NAV } from './types';

export default {
  [TOGGLE_SIDE_NAV](state) {
    state.hasSideNav = !state.hasSideNav;
  }
};
